<template>
  <div
    v-if="!isEmptyData(items) && hasValidColumns"
    class="cal-drayage-table orders"
    ref="imdl"
    @click="handleCellClick"
  >
    <e-table
      name="calimdl"
      :items="items"
      :virtual="virtual"
      :rowClass="rowClass"
      :cellClass="cellClass"
      :highlight="{ hover: false, click: true }"
      :defaultSort="defaultSort"
      :coreColumnDefs="columnDefs"
      :columnOptions="columnOptions"
      :columnEvent="columnEvent"
      :maxHeight="maxHeight"
      :getHeight="getHeight"
      :bufferScale="bufferScale"
      @contextmenu="contextMenu.trigger"
    />
    <e-contextmenu
      ref="contextmenu"
      :target="$refs.imdl"
      :options="contextMenu.options"
      @handle="contextMenu.handle"
    />
  </div>
</template>
<script>
import api from "@/default/utils/api";
import "@/default/pages/containers/calendar/cells/drayage.js";
import "@/default/pages/containers/calendar/legacy/legacy.js";
import "@/default/pages/containers/shared/shared.js";

export default {
  name: "ContainerCalendarImdl",
  mixins: [api],
  props: {
    mark: {
      type: String,
      required: true,
    },
    hubId: {
      type: Number,
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    virtual: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLegacy: null,
      contextMenu: {
        options: [
          {
            type: "SEPARATOR",
          },
          {
            label: "View Order",
            type: "view-order",
          },
          {
            label: "Edit Order",
            type: "edit-order",
          },
          {
            label: "Street Turns",
            type: "street-turns",
          },
          {
            label: "Dispatch Stats",
            type: "dispatch-stats",
          },
        ],
        trigger: (row, rowIndex, event) => {
          this.$refs.contextmenu.trigger(row, rowIndex, event);
        },
        handle: (type, row) => {
          let options = {};
          switch (type) {
            case "view-order":
              options = this.viewOrderOptions(row.id);
              Dialog.open({ width: "900px", ...options });
              break;
            case "edit-order":
              options = this.editOrderOptions(row.id);
              Dialog.open({ width: "900px", ...options });
              break;
            case "street-turns":
              Dialog.open({
                componentPath: "pages/containers/street_turns",
                width: "90%",
                clickToClose: true,
                container: row,
              });
              break;
            case "dispatch-stats":
              Dialog.open({
                componentPath: "pages/containers/dispatch_stats",
                width: "1200px",
                clickToClose: true,
                container: row,
              });
              break;
          }
        },
      },
      coreColumnDefs: [
        {
          title: "ID",
          field: "id",
          key: "id",
          width: 80,
          minWidth: 80,
          fixed: "left",
          classes: "cell-style",
          component: "drayage-id",
        },
        {
          title: "Action",
          key: "action",
          width: 72,
          minWidth: 72,
          fixed: "left",
          classes: "cell-style",
          component: "drayage-action",
        },
        {
          title: "Type",
          field: "abbrev_type",
          key: "type",
          width: 65,
          component: "ve-table-column",
        },
        {
          title: "Customer",
          field: "customer.name",
          key: "customer",
          width: 120,
          minWidth: 150,
          component: "drayage-customer",
        },
        {
          title: "Operations",
          field: "truckers[0].name",
          key: "operations",
          width: 240,
          minWidth: 240,
          legacy: false,
          component: "container-routes",
        },
        {
          title: "Operations",
          field: "truckers[0].name",
          key: "operations",
          width: 325,
          minWidth: 325,
          legacy: true,
          component: "legacy-routes",
        },
        {
          title: "Route EST",
          field: "route_est",
          key: "route_est",
          width: 80,
          minWidth: 80,
          classes: "cell-style",
          component: "route-est",
        },
        {
          title: "Route Status",
          field: "route.name",
          key: "route_status",
          width: 150,
          minWidth: 150,
          legacy: false,
          classes: "cell-style tight",
          component: "route-status",
        },
        {
          title: "Instructions",
          field: "instructions",
          key: "instructions",
          width: 150,
          minWidth: 150,
          legacy: false,
          component: "drayage-instructions",
        },
        {
          title: "Street Turn",
          field: "street_turn.id",
          key: "street_turn",
          width: 90,
          minWidth: 90,
          component: "drayage-street-turn",
        },
        {
          title: "AR",
          field: "charges.receivable",
          key: "ar",
          width: 75,
          minWidth: 75,
          aliasName: "Accts. Receivable",
          component: "drayage-ar",
        },
        {
          title: "AP",
          field: "charges.payable",
          key: "ap",
          width: 75,
          minWidth: 75,
          aliasName: "Accts. Payable",
          component: "drayage-ap",
        },
        {
          title: "Profit",
          field: "charges.profit",
          key: "profit",
          width: 75,
          minWidth: 75,
          component: "drayage-profit",
        },
        {
          title: "Warehouse",
          field: "warehouses[0].name",
          key: "wname",
          width: 150,
          aliasName: "Warehouse Name",
          component: "drayage-warehouse-name",
        },
        {
          title: "City",
          field: "warehouses[0].city",
          key: "wcity",
          width: 75,
          aliasName: "Warehouse City",
          component: "drayage-warehouse-city",
        },
        {
          title: "ST",
          field: "warehouses[0].state",
          key: "wstate",
          width: 38,
          aliasName: "Warehouse State",
          component: "drayage-warehouse-state",
        },
        {
          title: "Appt. Time",
          field: "appointment",
          key: "appt",
          width: 135,
          minWidth: 135,
          component: "appt-time",
        },
        {
          title: "Ssline",
          field: "ssline.name",
          key: "ssline",
          width: 75,
          component: "ve-table-column",
        },
        {
          title: "Terminals",
          field: "terminals",
          key: "terminals",
          width: 100,
          component: "drayage-terminals",
        },
        {
          title: "Depots",
          field: "depots",
          key: "depots",
          width: 100,
          component: "drayage-depots",
        },
        {
          title: "Size/Type",
          field: "ctype",
          key: "ctype",
          width: 72,
          component: "drayage-ctype",
        },
        {
          title: "PRI",
          field: "priority.value",
          key: "pri",
          width: 50,
          aliasName: "Priority",
          classes: "cell-style",
          component: "drayage-priority",
        },
        {
          title: "TRI",
          field: "triaxle",
          key: "tri",
          width: 50,
          aliasName: "Triaxle",
          classes: "cell-style",
          component: "drayage-triaxle",
        },
        {
          title: "HAZ",
          field: "haz_cargo",
          key: "hazmats",
          width: 50,
          classes: "cell-style",
          component: "drayage-haz",
        },
        {
          title: "Commodity",
          field: "commodity",
          key: "commodity",
          width: 150,
          minWidth: 150,
          length: 80,
          classes: "leading-tight tracking-tighter",
          component: "ve-table-column",
        },
        {
          title: "CONT.#",
          field: "container_no",
          key: "container_no",
          width: 145,
          minWidth: 145,
          classes: "cell-style tight",
          component: "drayage-cont-no",
        },
        {
          title: "REF.#",
          field: "reference_no",
          key: "reference_no",
          width: 110,
          component: "ve-table-column",
        },
        {
          title: "SSLine B/L#",
          field: "bl_no",
          key: "bl_no",
          width: 120,
          component: "ve-table-column",
        },
        {
          title: "Chassis#",
          field: "chassis_no",
          key: "chassis_no",
          width: 105,
          component: "drayage-chassis-no",
        },
        {
          title: "Pickup#",
          field: "pickup_no",
          key: "pickup_no",
          width: 75,
          only: "import",
          component: "ve-table-column",
        },
        {
          title: "Term. ETA",
          field: "eta",
          key: "eta",
          path: "eta_fmt",
          width: 90,
          minWidth: 90,
          aliasName: "Term. ETA",
          only: "import",
          component: "drayage-eta",
        },
        {
          title: "Term. LFD",
          field: "lfd",
          key: "lfd",
          path: "lfd_fmt",
          width: 90,
          minWidth: 90,
          aliasName: "Term. LFD",
          only: "import",
          classes: "cell-style tight",
          component: "drayage-lfd",
        },
        {
          title: "Vendor",
          field: "vendor",
          key: "vendor",
          width: 80,
          component: "ve-table-column",
        },
        {
          title: "PD LFD",
          field: "per_diem_lfd",
          key: "per_diem_lfd",
          path: "per_diem_lfd_fmt",
          width: 90,
          minWidth: 90,
          aliasName: "Per Diem LFD",
          classes: "cell-style tight",
          component: "drayage-pd-lfd",
        },
        {
          title: "Line LFD",
          field: "line_lfd",
          key: "line_lfd",
          path: "line_lfd_fmt",
          width: 90,
          minWidth: 90,
          only: "import",
          classes: "cell-style tight",
          component: "drayage-line-lfd",
        },
        {
          title: "Empty Rel.#",
          field: "empty_release_no",
          key: "empty_release_no",
          width: 100,
          aliasName: "Empty Release#",
          only: "export",
          component: "ve-table-column",
        },
        {
          title: "ERD",
          field: "erd",
          key: "erd",
          path: "erd_fmt",
          width: 90,
          minWidth: 90,
          aliasName: "Early Receiving Date",
          only: "export",
          component: "ve-table-column",
        },
        {
          title: "COD",
          field: "cod",
          key: "cod",
          path: "cod_fmt",
          width: 90,
          minWidth: 90,
          aliasName: "Cut Off Date",
          only: "export",
          classes: "cell-style tight",
          component: "drayage-cod",
        },
        {
          title: "Notify Ready",
          field: "notified_at",
          key: "notified_at",
          width: 100,
          component: "drayage-notified-at",
        },
        {
          title: "Dispatch",
          field: "dispatch_comment",
          key: "dispatch_comment",
          width: 125,
          classes: "cell-style tight",
          component: "drayage-dispatch-comment",
        },
        {
          title: "Tasks",
          key: "tasks",
          width: 150,
          minWidth: 150,
          fixed: "right",
          classes: "cell-style tight",
          component: "drayage-tasks",
        },
      ],
    };
  },
  mounted() {
    this.isLegacy = this.$store.settings.calendarLegacy;
  },
  updated() {
    this.refineItems();
  },
  beforeDestroy() {
    this.coreColumnDefs = [];
  },
  watch: {
    items() {
      setTimeout(() => window.dispatchEvent(new Event("resize")), 100);
    },
  },
  computed: {
    defaultColorStylesDisabled() {
      return this.getSettings("calendarDefaultColorStylesDisabled", false);
    },
    hasValidColumns() {
      return this.columnDefs.length > 0;
    },
    columnOptions() {
      return {
        hubId: this.hubId,
        isImport: this.isImport,
        isXtown: this.isXtown,
        trace: this.$store.envs.trace,
        opsDisplay: this.calendarOpsDisplay,
        curApptDate: this.curApptDate,
        splitStr: this.splitStr,
      };
    },
    curApptDate() {
      return /\d{4}-\d{2}-\d{2}/.test(this.mark) ? this.mark : null;
    },
    calendarOpsDisplay() {
      return this.getSettings("calendarOpsDisplay", "default");
    },
    columnsToHideByMark() {
      return {
        upcoming_loads: [
          "operations",
          "route_est",
          "route_status",
          "instructions",
          "ar",
          "ap",
          "profit",
        ],
      };
    },
    columnDefs() {
      const columns = this.coreColumnDefs
        .filter((o) => o.only == null || o.only == this.type.toLowerCase())
        .filter((o) => o.legacy == null || o.legacy == this.isLegacy);
      const columnsToHide = this.columnsToHideByMark[this.mark] || [];
      return columns.filter((o) => !columnsToHide.includes(o.key));
    },
    layout() {
      return this.$store.layouts.calendar || {};
    },
    defaultSort() {
      return this.layout.color_styles ? { prop: "rank", order: "asc" } : {};
    },
    maxHeight() {
      return this.virtual ? "calc(100vh - 156px)" : "auto";
    },
    bufferScale() {
      const scale = Math.max(1, Math.round(this.items.length / 25));
      return Math.min(scale, 10);
    },
  },
  methods: {
    getHeight() {
      const el = document.querySelector("#container-on-calendar");
      return el ? el.offsetHeight - 105 : 0;
    },
    rowClass({ row }) {
      let rowStyles = { locked: row.locked };
      if (row.color) rowStyles[`row-${row.color}`] = true;
      if (!row.color && !this.isBroker) rowStyles.brokered = row.brokered;
      if (this.layout.color_styles && !this.defaultColorStylesDisabled) {
        Object.assign(rowStyles, {
          hold: row.appt_hold,
          hp: row.priority.name === "high",
        });
        if (!row.color && row.mission) rowStyles[row.mission] = true;
      }
      Object.assign(rowStyles, { hazmats: row.haz_cargo });
      return rowStyles;
    },
    cellClass({ row, column, rowIndex }) {
      if (column.field == "container_no") return `cell-${row.type_color}`;
      const portOnly = ["line_lfd"];
      const railOnly = ["eta", "pickup_no"];
      const rail = row.drayage_mode == "rail";
      const unused =
        (rail && portOnly.includes(column.field)) ||
        (!rail && railOnly.includes(column.field));
      if (unused) return "cell-style cell-unused";
    },
    columnEvent(fn, ...args) {
      this[fn](...args);
    },
    autoSave(item, column, value) {
      let params = { type: item.type, column, value };
      this.$http
        .put(`/api/v1/attrs/${item.id}`, params)
        .then((response) => {
          this.$message({
            message: "It was changed successfully",
            type: "success",
          });
          if (column == "weight") {
            this.checkTriaxle(item);
          }
        })
        .catch((err) => {
          this.$message({ message: err.response.data.errors, type: "error" });
        });
    },
    checkTriaxle(item) {
      this.$http
        .post("/api/v1/containers/is_triaxle", {
          container: { ctype: item.ctype, weight: item.weight },
        })
        .then((response) => {
          if (response.data.triaxle && !item.triaxle) {
            this.$confirm(
              "Do you want to apply the triaxle to this move?",
              "Triaxle Weight",
              {
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                type: "warning",
              },
            )
              .then(() => {
                this.autoSave(item, "triaxle", true);
              })
              .catch(() => {});
          }
        })
        .catch((err) => {});
    },
    refineItems() {
      this.items.forEach((item) => {
        let firstNoApptFound = false;
        item.transports.forEach((route) => {
          //  only display the first no appt route
          if (this.mark == "not_sched" && !route.appt_date) {
            if (firstNoApptFound) this.$set(route, "hidden", true);
            firstNoApptFound ||= true;
          }
        });
      });
    },
    handleCellClick(event) {
      // Find the closest element with data-action attribute
      let target = event.target;
      let action = target.getAttribute("data-action");
      let orderId = target.getAttribute("data-order-id");

      // If the clicked element doesn't have data attributes, look up the DOM tree
      while (target && !action) {
        target = target.parentElement;
        if (target) {
          action = target.getAttribute("data-action");
          orderId = target.getAttribute("data-order-id");
        }
      }

      if (!action) return;

      event.preventDefault();
      event.stopPropagation();

      // Route to appropriate method based on action
      switch (action) {
        case "viewOrder":
          this.viewOrder(orderId);
          break;
        case "showReceivable":
          this.showReceivable(orderId);
          break;
        case "showPayable":
          this.showPayable(orderId);
          break;
        case "toEdit":
          this.toEdit(orderId);
          break;
        case "showTrace":
          const containerNo = target.getAttribute("data-container-no");
          const marker = target.getAttribute("data-marker");
          this.showTrace(orderId, containerNo, marker);
          break;
        case "showPickups":
          this.showPickups(orderId);
          break;
        case "showEquipmentRelease":
          this.showEquipmentRelease(orderId);
          break;
        case "showCompany":
          const companyId = target.getAttribute("data-company-id");
          this.showCompany(companyId);
          break;
        default:
          console.warn("Unknown action:", action);
      }
    },
    viewOrder(orderId) {
      const options = this.viewOrderOptions(orderId);
      Dialog.open({ width: "900px", clickToClose: true, ...options });
    },
    showReceivable(orderId) {
      Dialog.open({
        width: "800px",
        height: "auto",
        pivotY: 0.5,
        clickToClose: true,
        title: "Container: " + orderId,
        url: "/containers/" + orderId + "/receivable_charges",
      });
    },
    showPayable(orderId) {
      Dialog.open({
        width: "800px",
        height: "auto",
        pivotY: 0.5,
        clickToClose: true,
        title: "Container: " + orderId,
        url: "/containers/" + orderId + "/payable_charges",
      });
    },
    toEdit(orderId) {
      const item = this.items.find((item) => item.id === parseInt(orderId));
      if (item) this.$set(item, "editing", !item.editing);
    },
    showTrace(orderId, containerNo, marker) {
      Dialog.open({
        componentPath: "pages/traces/widget",
        width: "960px",
        clickToClose: true,
        id: parseInt(orderId),
        marker: marker,
        type: "Container",
        name: containerNo,
      });
    },
    showPickups(orderId) {
      const item = this.items.find((item) => item.id === parseInt(orderId));
      if (item) {
        Dialog.open({
          componentPath: "pages/containers/pickups",
          width: "95%",
          pivotY: 0,
          clickToClose: true,
          container: item,
        });
      }
    },
    showEquipmentRelease(target) {
      NApp.turboClick(target);
    },
    showCompany(companyId) {
      Dialog.open({
        componentPath: "pages/companies/detail",
        width: "500",
        height: "auto",
        pivotY: 0.5,
        clickToClose: true,
        id: companyId,
      });
    },
  },
};
</script>
<style lang="scss">
.cal-drayage-table {
  @apply clear-both p-0 mx-auto overflow-hidden;
}
</style>
